import React from 'react'
import { Tile, ProgressBar } from '@carbon/react'
import styles from './MetricCard.module.scss'

export interface MetricCardProps {
  title: string
  value: string | number
  subtitle?: string
  icon?: React.ElementType
  trend?: 'positive' | 'negative' | 'neutral'
  trendValue?: string
  /** Progress value 0-100 to show a progress bar (e.g. for completion rate) */
  progress?: number
}

export function MetricCard({
  title,
  value,
  subtitle,
  icon: Icon,
  trend,
  trendValue,
  progress,
}: MetricCardProps) {
  return (
    <Tile className={styles.metricCard}>
      <div className={styles.header}>
        <span className={styles.title}>{title}</span>
        {Icon && (
          <div className={styles.icon}>
            <Icon size={20} />
          </div>
        )}
      </div>
      <div className={styles.value}>{value}</div>
      {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      {progress !== undefined && (
        <ProgressBar
          label=""
          value={progress}
          max={100}
          size="big"
          className={styles.progressBar}
        />
      )}
      {trend && trendValue && (
        <p className={`${styles.trend} ${styles[`trend-${trend}`]}`}>
          {trendValue}
        </p>
      )}
    </Tile>
  )
}
